// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eaf0661b","239":"a63c6eb3","455":"58064e24"}[chunkId] + ".chunk.js";
};